import { z } from 'zod'

import { serverItemSchema, nullableString } from '../../utils/schema'
import { baseClientDetailSchema } from '../../clients/clients.schema'

import type { E164Number } from 'libphonenumber-js'

type UpdateClientInput = z.infer<typeof updateClientInputSchema>
type CreateClientResponse = z.infer<typeof createClientOptInResponseSchema>

type CreateOptInParams = {
  e164: E164Number
}

const createClientOptInResponseSchema = z.object({
  result: z.object({
    client: serverItemSchema.extend({
      firstName: nullableString,
      lastName: nullableString,
    }),
  }),
})

const updateClientResponseSchema = z.object({
  result: baseClientDetailSchema,
})

const updateClientInputSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
})

export type { UpdateClientInput, CreateClientResponse, CreateOptInParams }
export {
  createClientOptInResponseSchema,
  updateClientInputSchema,
  updateClientResponseSchema,
}
